import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from '../../../helpers/hooks';
import { StepProps } from '../interfaces';
import { Map } from '../../../common/Map';
import { Button } from '../../../common/styled/form';
import { AppState } from '../../../store/interfaces';
import { getMarkers } from '../../../store/map/actions';

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  background: ${(props) => props.theme.background};

  > div:first-child {
    margin-top: 16px;
    font-size: 24px !important;
    color: ${(props) => props.theme.altText};
  }

  #markers-description {
    margin-top: 8px;
    padding: 0 10px;
    text-align: center;
    font-size: 18px;
    color: ${(props) => props.theme.textColor};
  }

  #map-details-wrapper {
    border-radius: 0 0 16px 16px;
  }

  #map-container {
    margin: 16px 0;
    flex: 1;
    position: relative;
  }

  #button-container {
    height: 41px;
    margin-bottom: 16px;
    text-align: center;
    button {
      font-size: 22px !important;
      display: inline-flex;
      justify-content: center;
      color: #ec42ce;
    }
  }
`;

export const Markers: React.FC<StepProps> = React.memo(function ({
  setNextWizardStep,
  showContinueButton = true,
}) {
  const { t } = useTranslation();
  const markers = useSelector((app: AppState) => app.map.markers.list);
  const isMarkersLoading = useSelector((app: AppState) => app.map.markers.isLoading);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMarkers.request());
  }, []);

  return (
    <Container>
      <div style={{ textAlign: 'center' }}>{t('settings.wizard.markers.title')}</div>
      <div
        id="markers-description"
        dangerouslySetInnerHTML={{ __html: t('settings.wizard.markers.body') }}
      />
      <div id="map-container">
        <Map hideHint isEditMode />
      </div>
      {showContinueButton && (
        <div id="button-container">
          {markers.length !== 0 && (
            <Button
              isLoading={isMarkersLoading}
              isDisabled={markers.length === 0}
              onClick={setNextWizardStep}
            >
              {t('settings.wizard.buttonContinue')}
            </Button>
          )}
        </div>
      )}
    </Container>
  );
});
